import React from "react";
import { BoxProps } from "@mui/material";
import { Box, Typography } from "@tiny/components";
import useBreakpoints from "@tiny/components/src/hooks/useBreakpoints";

export interface SegmentPanelProps extends BoxProps {
  title: string;
  children?: React.ReactNode;
}

function SegmentPanel(props: SegmentPanelProps) {
  const { title, children, ...boxProps } = props;

  const { mdUp } = useBreakpoints();

  return (
    <Box
      {...boxProps}
      component="section"
      bgcolor="common.white"
      borderRadius="8px"
    >
      <Box px={mdUp ? 6 : 4} pt={mdUp ? 5 : 4} pb={0}>
        <Typography
          variant="h4"
          color="grey"
          tone={900}
          m={0}
          fontWeight="semiBold"
        >
          {title}
        </Typography>
      </Box>
      <Box>{children}</Box>
    </Box>
  );
}

export default SegmentPanel;
